import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { pagetypeActions } from "../../actions";
import { PageTypesNav } from "./PageTypesNav";
import { AddGroupModal } from "./AddGroupModal";

function PageGroupsLibrary(props) {
  const {
    pagetypes,
    getPageGroups,
    getPageTypesForGroup,
    addPageTypeForGroup,
    removePageTypeForGroup,
  } = props;
  const groups = pagetypes?.groups;
  const typesForGroup = pagetypes?.types_for_group;

  const { id } = useParams();
  const org_id = Number(id);

  const [currentPageGroup, setCurrentPageGroup] = useState(0);
  const [currentPageGroupName, setCurrentPageGroupName] = useState("");
  const [currentTypesForGroup, setCurrentTypesForGroup] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    console.log(org_id);
    getPageGroups(org_id);
  }, [org_id, showModal]);

  useEffect(() => {
    console.log(currentPageGroup);
    getPageTypesForGroup(org_id, currentPageGroup);
  }, [currentPageGroup]);

  function getCurrentPageGroupName(pageGroupId) {
    return groups?.find((group) => group.page_group_id === pageGroupId)
      .page_group_name;
  }

  function handleTypeAssignment(event, pageGroupId, typeId) {
    console.log(pageGroupId + " " + typeId);
    if (event.target.checked) {
      addPageTypeForGroup(org_id, pageGroupId, typeId);
    } else {
      removePageTypeForGroup(org_id, pageGroupId, typeId);
    }
  }

  function getCurrentGroupDisplayName() {
    if (currentPageGroupName === "") return "(no group selected)";
    else return currentPageGroupName;
  }

  const headers = ["group name"];

  const tableHeaders = headers.map((header, i) => <th>{header}</th>);

  const tableRows = groups?.map((group, i) => (
    <tr
      id={group.page_group_id}
      onClick={(event) => {
        const id = event.target.parentElement.id;
        const name = getCurrentPageGroupName(Number(id));
        setCurrentPageGroup(id);
        setCurrentPageGroupName(name);
      }}
    >
      <td>{group.page_group_name}</td>
    </tr>
  ));

  const typeRows = typesForGroup?.map((type, i) => (
    <tr>
      <td>
        <input
          type="checkbox"
          name={type.page_type_id}
          id={type.page_type_id}
          checked={type.selected ? "checked" : ""}
          onClick={(event) => {
            handleTypeAssignment(event, currentPageGroup, type.page_type_id);
          }}
        />
      </td>
      <td>{type.page_type_name}</td>
    </tr>
  ));

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <br />
      <div class="refresh"></div>
      <div class="searchMain">
        <div class="contentContainerLeftNav">
          <div class="leftNav">
            <PageTypesNav parent="groups" />
          </div>
          <div class="rightContent">
            <div class="pageGroupsLibraryContainer">
              <div class="leftPane">
                <div class="groupsHeader">
                  All Groups
                  <span class="addGroupSpan" onClick={toggleModal}>
                    +
                  </span>
                  <br />
                  <br />
                </div>
                <table class="paleBlueRows rowHover">
                  <tbody>{tableRows}</tbody>
                </table>
              </div>
              <div class="rightPane">
                <div class="groupsHeader">
                  Current Group:&nbsp;{getCurrentGroupDisplayName()}
                  <br />
                  <br />
                </div>

                <div class="rightPaneTable">
                  {typesForGroup && currentPageGroup && typeRows && (
                    <table class="paleBlueRows rowHover">
                      <tbody>{typeRows}</tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="addGroupModalWrapper"
        style={{ visibility: showModal ? "visible" : "hidden" }}
      >
        <AddGroupModal org_id={org_id} handleClose={toggleModal} />
      </div>
    </>
  );
}

function mapStateToProps(state) {
  const { pagetypes } = state;
  return {
    pagetypes,
  };
}

const actionCreators = {
  getPageTypeInspection: pagetypeActions.getPageTypeInspection,
  getPageGroups: pagetypeActions.getPageGroups,
  getPageTypesForGroup: pagetypeActions.getPageTypesForGroup,
  addPageTypeForGroup: pagetypeActions.addPageTypeForGroup,
  removePageTypeForGroup: pagetypeActions.removePageTypeForGroup,
};
const connectedPageGroupsLibrary = connect(
  mapStateToProps,
  actionCreators
)(PageGroupsLibrary);
export { connectedPageGroupsLibrary as PageGroupsLibrary };
